import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AzzurroTable, KeyValueBlockModule } from 'ngx-zcs-components';
import { MatIconModule } from '@angular/material/icon';

import { Psc100DashboardComponent } from './psc100-dashboard.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { GenericDeviceDashboardModule } from '../generic-device-dashboard/generic-device-dashboard.module';

@NgModule({
  declarations: [
    Psc100DashboardComponent,
  ],
  exports: [
    Psc100DashboardComponent,
  ],
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    GenericDeviceDashboardModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
  ]
})
export class Psc100DashboardModule { }
